import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { STATSIG_INIT_CONFIG, StatsigService } from '@statsig/angular-bindings';

import { ILogger } from '@shure/shared/angular/utils/logging';

import { StatsigConfiguration, StatsigProvider } from './statsig-provider';

export interface StatsigConfig {
	clientKey: string;
	tier: string;
	proxyApi?: string;
	appName?: string | null;
}

export function provideStatsigFeatureFlags(statsigConfig: StatsigConfig): EnvironmentProviders {
	return makeEnvironmentProviders([
		{
			provide: STATSIG_INIT_CONFIG,
			useValue: {
				sdkKey: statsigConfig.clientKey,
				user: {
					userID: undefined
				},
				options: {
					environment: {
						tier: statsigConfig.tier
					},
					networkConfig: {
						api: statsigConfig?.proxyApi
					},
					custom: {
						// eslint-disable-next-line @typescript-eslint/naming-convention
						'blue-green-app-name': statsigConfig.appName
					}
				}
			}
		},
		{
			provide: StatsigProvider,
			// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
			useFactory: (logger: ILogger, statsigService: StatsigService, statsigInitConfig: StatsigConfiguration) => {
				return new StatsigProvider(logger, statsigService, statsigInitConfig);
			},
			deps: [ILogger, StatsigService, STATSIG_INIT_CONFIG]
		}
	]);
}
